import React from 'react';
import { FUNDING_SEQUENCE_PHASES } from '../../utils/funding/constants';

const FundingSequenceFilters = ({ sequenceStatus, onSequenceStatusChange, sequences, activeSequenceId, onSequenceChange }) => (
  <div className="grid gap-3 sm:grid-cols-2">
    <label className="block text-sm">
      <span className="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-[var(--fg-muted)]">Sequence</span>
      <select
        value={activeSequenceId || ''}
        onChange={(event) => onSequenceChange(event.target.value)}
        className="w-full rounded-xl border border-[var(--fg-line)] bg-[var(--fg-panel-soft)] px-3 py-2 text-sm text-[var(--fg-text)]"
      >
        <option value="">Select sequence</option>
        {sequences.map((sequence) => (
          <option key={sequence.id} value={sequence.id}>{sequence.name}</option>
        ))}
      </select>
    </label>
    <label className="block text-sm">
      <span className="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-[var(--fg-muted)]">Sequence status</span>
      <select
        value={sequenceStatus}
        onChange={(event) => onSequenceStatusChange(event.target.value)}
        className="w-full rounded-xl border border-[var(--fg-line)] bg-[var(--fg-panel-soft)] px-3 py-2 text-sm text-[var(--fg-text)]"
      >
        <option value="">All statuses</option>
        {['Draft', 'Active', 'Paused', 'Completed', 'Archived'].map((status) => (
          <option key={status} value={status}>{status}</option>
        ))}
      </select>
    </label>
    <div className="sm:col-span-2 text-xs text-[var(--fg-muted)]">
      Phases: {FUNDING_SEQUENCE_PHASES.join(' · ')}
    </div>
  </div>
);

export default FundingSequenceFilters;
